import { AdminHeader } from "Components/AdminHeader";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "reactfire";
import {
  AccessProvider,
  AccessType,
  FULL_ACCESS_GROUP,
  LIMITED_ACCESS_CLAIM,
} from "Providers";
import { ParsedToken } from "firebase/auth";

export const AdminAuth = ({ children }) => {
  const { status, data: user } = useUser();
  const [claims, setClaims] = useState<ParsedToken>(null);

  useEffect(() => {
    if (status !== "loading") {
      if (user) {
        user.getIdTokenResult().then((res) => setClaims(res.claims));
        window.Sentry?.setUser({ email: user.email, id: user.uid });
      } else {
        setClaims({});
      }
    }
  }, [user, status]);

  if (status === "loading" || claims === null) {
    return <div>Loading</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const groups = claims.groups as string[] | undefined;

  const type: AccessType = groups?.includes(FULL_ACCESS_GROUP)
    ? "full"
    : claims[LIMITED_ACCESS_CLAIM] === true
      ? "limited"
      : "none";

  if (type === "none") {
    return <Navigate to="/403" replace />;
  }

  return (
    <AccessProvider type={type}>
      <AdminHeader />
      {children}
    </AccessProvider>
  );
};
